<template>
  <div class="not-available">
    <md-card>
      <md-card-header>
      <md-card-header-text>
        <div class="md-title">{{ message }}</div>
      </md-card-header-text>
      </md-card-header>
      <md-card-content>
        <p>
          <a
            @click="hasHistory() ? $router.go(-1) : $router.push('/frontpage')"
            class="back-link"
          >
            <md-icon>arrow_back</md-icon>
            Return to screen
          </a>
        </p>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
export default {
  name: "NotAvailable",

  data() {
    return {
      title: window.drupalSettings.controller.title,
      message: window.drupalSettings.controller.message
    };
  },

  methods: {
    log(msg) {
      console.log(msg);
    },
    hasHistory() {
      return window.history.length > 2;
    }
  }
};
</script>
<style lang="scss">
</style>
